<template>
  <div :id="`lineChart${indexId}`" class="line-chart"></div>
</template>

<script>
import { dataFormatter, returnFloat } from "@/utils/util";
export default {
  props: ["lineData", "indexId"],
  data() {
    return {
      xdata: [],
      seriesData: []
    };
  },
  created() {},
  mounted() {
    // this.drawline();
  },
  methods: {
    drawline() {
      this.xdata = this.lineData.dataList;
      let freqData = this.lineData.data && this.lineData.data["2"];
      let historyData = this.lineData.data && this.lineData.data["1"];
      let predictData = this.lineData.data && this.lineData.data["3"];
      this.setSeriesData(
        historyData,
        ["#cacaca", "rgba(245, 245, 245,0.9)"],
        "历史"
      );
      this.setSeriesData(freqData, ["#f47f37", "rgba(193,85,53,0.2)"], "高频");
      this.setSeriesData(
        predictData,
        ["#2ce4ff", "rgba(234, 249, 252,0.9)"],
        "预测"
      );
      let myChart = this.$echarts.init(
        document.getElementById(`lineChart${this.indexId}`)
      );
      let option = {
        tooltip: {
          trigger: "axis",
          transitionDuration: 0,
          formatter: function(params) {
            let dateFormat = dataFormatter(new Date(params[0].value[0])); //"2020-06-30"
            return params[1]
              ? `${dateFormat}<br>${params[0].seriesName}：${params[0].data[1]}<br>${params[1].seriesName}：${params[1].data[1]}`
              : `${dateFormat}<br>${params[0].seriesName}：${params[0].data[1]}`;
          }
        },
        legend: {
          itemGap: 80,
          x:'right',
          y:'top',
          padding:[10,30,0,0],
          // show: false,
          textStyle: {
            color: "#000"
          },
          // icon: "rect",
          // itemWidth: 14, // 设置宽度
          // itemHeight: 6, // 设置高度
          data: ["历史", "高频", "预测"]
        },
        grid: {
          containLabel: true,
          bottom: "14%",
          left: "4%",
          right: "4%",
          top: "14%"
        },
        xAxis: {
          type: "time",
          data: [...new Set(this.xdata)].sort(),
          id: "overlinexAxis",
          position: "bottom",
          boundaryGap: true,
          axisLabel: {
            color: "#808080",
            // interval: 100000,
            formatter: params => {
              let flag = dataFormatter(new Date(params));
              if (
                flag == [...new Set(this.xdata)].sort()[0] ||
                flag ==
                  [...new Set(this.xdata)].sort()[
                    [...new Set(this.xdata)].sort().length - 1
                  ]
              ) {
                return flag;
              } else {
                return "";
              }
            },
            showMinLabel: true,
            showMaxLabel: true
          },
          axisLine: {
            //x轴轴线
            lineStyle: {
              color: "#dedede",
              width: 0.5,
              type: "solid"
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true,
            inside: true
          },
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          id: "overlineyAxis",
          type: "value",
          nameGap: 10,
          scale: true,
          splitNumber: 1,
          boundaryGap: true,
          axisLabel: {
            margin: 12,
            color: "#999",
            fontFamily: "arial",
            fontSize: 10
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(160,160,160,.1)",
              type: "solid"
            }
          },
          axisTick: {
            onGap: false,
            show: false
          },
          splitArea: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(160,160,160,.1)"
            }
          },
          axisPointer: {
            show: false
          }
        },
        series: this.seriesData
      };
      option.yAxis.axisLabel.formatter = value => {
        return returnFloat(value);
      };
      option.yAxis.min = function(value) {
        return value.min;
      };
      option.yAxis.max = function(value) {
        return value.max;
      };
      this.$nextTick(() => {
        myChart.setOption(option, true);
      });
    },
    setSeriesData(data, color, name) {
      // let markLine = "";
      // if (name == "预测") {
        // let xdata = [...new Set(this.xdata)].sort();
        // markLine = {
        //   symbol: "none",
        //   lineStyle: {
        //     type: "dashed",
        //     color: "#2ce4ff",
        //     width: 0.5
        //   },
        //   textStyle: {
        //     color: "#2ce4ff"
        //   },
        //   label: {
        //     padding: [0, 0, 0, 0],
        //     fontSize: 10 //标线的标签文字大小,
        //   },
        //   data: [
        //     {
        //       xAxis: xdata[xdata.length - 1]
        //     }
        //   ]
        // };
      // }
      // let xdata = [],
      let indexVal = [];
      data &&
        data.map(val => {
          // xdata.push(val.indexDate);
          indexVal.push([val.indexDate, val.indexValue.toFixed(2)]);
        });
      let itemObj = {
        name: name,
        type: "line",
        symbol: "none",
        itemStyle: {
          normal: {
            color: color[0],
            lineStyle: {
              color: color[0],
              // width: 0.5
            }
          }
        },
        areaStyle: {
          color: color[1]
        },
        // markLine,
        data: indexVal,
        smooth: true
      };
      this.seriesData.push(itemObj);
    }
  }
};
</script>

<style  lang="scss" scoped>
.line-chart {
  height: 100%;
}
</style>